import { render, staticRenderFns } from "./HelpdeskRelatedEmailsTab.vue?vue&type=template&id=295c5cba&scoped=true&"
import script from "./HelpdeskRelatedEmailsTab.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskRelatedEmailsTab.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskRelatedEmailsTab.vue?vue&type=style&index=0&id=295c5cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c5cba",
  null
  
)

export default component.exports